<template>
  <v-container class="doorphones" fluid>
    <!-- Шапка страницы -->
    <div class="doorphones-header">
      <h1 class="doorphones-header__title">{{ $route.meta.title }}</h1>
      <div class="doorphones-header__actions">
        <v-tooltip bottom v-if="filters.status === 'null' || filters.status === '-1'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="doorphones-header__btn"
              v-bind="attrs"
              v-on="on"
              dark
              rounded
              :loading="isMassSipLoading"
              @click.prevent="onMassSipStatus"
            >
              <v-icon left>mdi-refresh</v-icon>
              Обновить SIP
            </v-btn>
          </template>
          <span>Обновить SIP статус у всех домофонов на странице</span>
        </v-tooltip>
        <v-menu
          v-if="$checkPermission('export_csv_doorphone')"
          bottom
          left
          offset-y
          origin="bottom left"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              outlined
              class="doorphones-header__btn text-none"
              v-bind="attrs"
              v-on="on"
              dark
              rounded
            >
              <v-icon left>mdi-download</v-icon>
              Скачать отчёт
            </v-btn>
          </template>
          <v-list class="doorphones-report-menu" dense>
            <v-list-item @click="downloadReport()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-document-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Полный отчёт</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadReportPage()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-file-table-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Отчёт на странице</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('create_doorphone')"
          color="primary"
          class="doorphones-header__btn text-none"
          dark
          rounded
          to="/doorphone/new"
        >
          <v-icon left>mdi-plus</v-icon>
          Новый домофон
        </v-btn>
      </div>
    </div>

    <!-- Фильтры + таблица -->
    <v-card class="doorphones-block mt-3" flat outlined>
      <div class="doorphones-filters">
        <div class="doorphones-filters__row">
          <div class="doorphones-filters__main">
            <div class="doorphones-filters__title">
              <v-icon left small>mdi-filter-variant</v-icon>
              Фильтры
            </div>
            <div class="filters-doorphones" :class="{ 'filters-doorphones-selectively-role-name': !disableFilterName }">
          <v-text-field
            v-model="filterAddress"
            @keyup="validateKeyUp"
            placeholder="Улица"
            outlined
            dense
            hide-details
            prepend-inner-icon="mdi-rename-box-outline"
            class="doorphones-filters__field"
          />
          <v-autocomplete
            :items="sipSelectList"
            v-model="sipStatusSearched"
            placeholder="Статус"
            item-text="text"
            item-value="value"
            prepend-inner-icon="mdi-progress-clock"
            outlined
            dense
            hide-details
            clearable
            class="doorphones-filters__field"
          />
          <v-autocomplete
            label="Тип домофона"
            v-model="filterType"
            :items="typesDoorphone"
            item-text="name"
            item-value="value"
            prepend-inner-icon="mdi-alert-circle-outline"
            class="doorphones-filters__field"
            outlined
            dense
            hide-details
            clearable
          />
          <div class="doorphones-filters__search-wrap">
            <v-btn
              v-if="isDisplaySmall"
              color="primary"
              class="text-none"
              dark
              rounded
              @click.prevent="filterDoorphones"
            >
              <v-icon left>mdi-magnify</v-icon>
              Поиск
            </v-btn>
          </div>
          <v-autocomplete
            label="Агент"
            v-model="filterAgent"
            :items="agents"
            v-if="disableFilterName"
            item-text="user.name"
            item-value="id"
            prepend-inner-icon="mdi-account-search"
            class="doorphones-filters__field"
            outlined
            dense
            hide-details
            clearable
            @change="onAgentFilterChange"
          />
          <v-autocomplete
            label="Участок МТО"
            v-model="filterMtoSector"
            :items="mtoSectorOptions"
            item-text="name"
            item-value="id"
            prepend-inner-icon="mdi-map-marker-radius"
            class="doorphones-filters__field"
            outlined
            dense
            hide-details
            clearable
            no-data-text="Участки не найдены"
            :disabled="isMtoSectorFilterDisabled"
            :hint="mtoSectorFilterHint"
            :persistent-hint="isMtoSectorFilterDisabled"
            :loading="mtoSectorsLoading"
          />
          <v-autocomplete
            label="Управляющая компания"
            v-if="disableFilterName"
            v-model="filterManagementCompany"
            :items="managementCompanies"
            item-text="name"
            item-value="id"
            prepend-inner-icon="mdi-home-account"
            class="doorphones-filters__field"
            outlined
            dense
            hide-details
            clearable
          />
          <div class="doorphones-filters__switch-wrap">
              <v-switch
                v-model="isSafeCityDoorphone"
                @change="showSafeCity()"
                class="mt-0"
                hide-details
                color="primary"
                label="Домофоны безопасного города"
              />
          </div>
            </div>
          </div>
          <div class="doorphones-filters__columns">
            <column-selector
              :visible-columns.sync="visibleColumns"
              :available-columns="doorphoneSettings.available_columns"
              :all-columns="allColumns"
              table-key="doorphones"
            />
          </div>
        </div>
        <div v-if="!isDisplaySmall" class="d-flex justify-center mt-2">
          <v-btn
            color="primary"
            class="text-none"
            dark
            rounded
            @click.prevent="filterDoorphones"
          >
            <v-icon left>mdi-magnify</v-icon>
            Поиск
          </v-btn>
        </div>
      </div>

      <v-divider class="my-0"></v-divider>

      <v-progress-linear v-if="loadingSettings" indeterminate color="primary"></v-progress-linear>
      <v-data-table
        v-if="!loadingSettings"
        class="table row-click doorphones-table"
        :headers="headersDoorphone"
        :items="doorphones"
        :options.sync="options"
        :server-items-length="totalDoorphones"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100, 500],
          showFirstLastPage: true,
        }"
        @click:row="rowDetailDoorphone"
      >
        <template v-slot:header.snapshotImage v-if="visibleColumns.includes('snapshotImage')">
          Изображение с домофона
          <v-icon @click="showSnapshot = !showSnapshot">mdi-image</v-icon>
        </template>

        <template v-slot:item.agent="{ item }" v-if="visibleColumns.includes('agent')">
          <div>
            {{ item.agent ? item.agent : (item.sip_status_text === 'Старый домофон' ? 'ООО \"КОМПАНИЯ ВОЛНА\"' : 'Неизвестный агент') }}
          </div>
        </template>

        <template v-slot:item.mto_sector="{ item }" v-if="visibleColumns.includes('mto_sector')">
          <doorphone-mto-sector-cell :sector="item.mto_sector" />
        </template>

        <template v-slot:item.payment_type="{ item }" v-if="visibleColumns.includes('payment_type')">
          {{ getPaymentType(item.payment_type) }}
        </template>

        <template v-slot:item.tariff="{ item }" v-if="visibleColumns.includes('tariff')">
          {{ item.tariff ? `${item.tariff} руб. в месяц` : 'Тариф не указан' }}
        </template>

        <template v-slot:item.sip_status="{ item }" v-if="!isDisplaySmall && visibleColumns.includes('sip_status')">
          <div>
            <v-icon x-small :color="item.sip_status_color">
              mdi-checkbox-blank-circle
            </v-icon>
            {{ item.sip_status_text }}
          </div>
        </template>

        <template v-slot:body v-if="isDisplaySmall">
          <tbody class="table" v-if="doorphones[0]">
          <template v-for="(item, index) in doorphones">
            <tr
              :key="index"
              @click.middle="clickDoorphoneWhell(item.id)"
              @click.prevent="clickDoorphone($event, item.id)"
            >
              <td v-if="visibleColumns.includes('id')">{{ item.id }}</td>
              <td
                v-if="visibleColumns.includes('address') && item.doors && item.doors.length > 1 && item.doors[1].is_active && roleName === 'admin'"
                class="pr-0"
                style="display: flex; align-items: center;"
              >
                <div>
                  {{ item.address }}
                </div>
                <v-spacer></v-spacer>
                <div @click.stop="openingAdditionalLine(index)" style="cursor: auto;">
                  <v-icon
                    color="black"
                    :class="{ 'rotate-icon': isLinksVisible && visibleIndex === index }"
                  >
                    mdi-chevron-down
                  </v-icon>
                </div>
              </td>
              <td v-else-if="visibleColumns.includes('address')">
                {{ item.address }}
              </td>
              <td v-if="visibleColumns.includes('region_name')">{{ item.region_name }}</td>
              <td v-if="visibleColumns.includes('concierge_number')">{{ item.dispatcher_phone || item.concierge_number }}</td>
              <td v-if="visibleColumns.includes('agent')">
                {{ item.agent ? item.agent : (item.sip_status_text === 'Старый домофон' ? 'ООО \"КОМПАНИЯ ВОЛНА\"' : 'Неизвестный агент') }}
              </td>
              <td v-if="visibleColumns.includes('diapason')">{{ item.diapason }}</td>
              <td v-if="visibleColumns.includes('management_company')">{{ item.management_company }}</td>
              <td v-if="visibleColumns.includes('management_group')">{{ item.management_group }}</td>
              <td v-if="visibleColumns.includes('mto_sector')">
                <doorphone-mto-sector-cell :sector="item.mto_sector" />
              </td>
              <td v-if="visibleColumns.includes('sip_status')">
                <div>
                  <v-icon x-small :color="item.sip_status_color">
                    mdi-checkbox-blank-circle
                  </v-icon>
                  {{ item.sip_status_text }}
                </div>
              </td>
              <td v-if="visibleColumns.includes('snapshotImage')">
                <v-img
                  v-show="showSnapshot"
                  :src="`${item.snapshot}`"
                  max-width="150"
                  class="ml-auto mr-auto my-4"
                  contain
                ></v-img>
              </td>
              <td v-if="visibleColumns.includes('model')">{{ item.model }}</td>
              <td v-if="visibleColumns.includes('payment_type')">{{ getPaymentType(item.payment_type) }}</td>
              <td v-if="visibleColumns.includes('tariff')">
                {{ item.tariff ? `${item.tariff} руб. в месяц` : 'Тариф не указан' }}
              </td>
              <td v-if="visibleColumns.includes('comment')">{{ item.comment }}</td>
            </tr>

            <tr
              v-if="isLinksVisible && visibleIndex === index"
              :key="'extra-' + index"
              class="extra-row"
              style="cursor: auto;"
            >
              <td :colspan="visibleColumns.length" style="padding-left: 0">
                <div v-for="(door, doorIndex) in item.doors" :key="doorIndex" class="door-item">
                  <div v-if="door.is_active" class="nested-container">
                    <span class="door-info" style="margin-left: 5px">Выход - {{ door.doornum }}</span>
                    <span class="door-info">Название - {{ door.name }}</span>
                    <template class="door-info" v-if="roleName === 'admin'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            text
                            tile
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="btn__icon pa-0 mr-1"
                            width="18"
                            height="18"
                            @click="openEditEnter(item)"
                          >
                            <v-icon size="large">mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Редактировать</span>
                      </v-tooltip>
                    </template>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          </tbody>

          <tbody v-else>
          <tr>
            <td :colspan="visibleColumns.length" style="text-align: center">Отсутствуют данные</td>
          </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="resultDialog" max-width="800" content-class="dialog-border-radius">
      <v-card class="doorphones-result-dialog">
        <v-card-title class="doorphones-result-dialog__title">
          <v-icon left>mdi-information-outline</v-icon>
          Результат обновления SIP-статусов
        </v-card-title>
        <v-card-text>
          <div v-if="massResult.summary" class="mb-4">
            <v-chip class="mr-2" color="blue" text-color="white" small>
              Обработано: {{ massResult.summary.processed }}
            </v-chip>
            <v-chip class="mr-2" color="green" text-color="white" small>
              Успешно: {{ massResult.summary.success }}
            </v-chip>
            <v-chip color="red" text-color="white" small>
              Ошибки: {{ massResult.summary.failed }}
            </v-chip>
          </div>

          <v-data-table
            class="table"
            :headers="resultHeaders"
            :items="massResult.results"
            :items-per-page="10"
            dense
            :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
          >
            <template v-slot:item.status="{ item }">
              <div style="display: inline-flex; align-items: center; gap: 8px;">
                <v-chip x-small label>{{ item.id }}</v-chip>
                <v-icon x-small :color="item.status ? 'green' : 'red'">mdi-checkbox-blank-circle</v-icon>
                {{ item.status ? 'Успешно' : 'Ошибка' }}
              </div>
            </template>
            <template v-slot:item.sip_status="{ item }">
              {{ getSipStatusText(item.sip_status) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import cp1251Encode from '@/mixins/cp1251Encode';
import ColumnSelector from '@/components/ColumnSelector.vue';
import DoorphoneMtoSectorCell from '@/components/doorphone/DoorphoneMtoSectorCell.vue';

export default {
  components: { ColumnSelector, DoorphoneMtoSectorCell },
  mixins: [ruDateFormatMixin, cp1251Encode],
  name: 'Doorphone',
  data () {
    return {
      isCreated: false,
      sipStatusSearched: '',
      filterAddress: '',
      showSnapshot: false,
      isDisplaySmall: true,
      disableFilterName: true,
      isSafeCityDoorphone: false,
      isMassSipLoading: false,
      totalDoorphones: 0,
      rotation: 0,
      visibleIndex: 0,
      isLinksVisible: false,
      loadingSettings: false,
      filterManagementCompany: '',
      filterAgent: '',
      filterMtoSector: '',
      filterType: '',
      mtoSectorsLoading: false,
      baseUrl: process.env.VUE_APP_API_URL,
      options: {
        itemsPerPage: 20,
        page: 1,
      },
      filters: { type: 'A,M' },
      sort: '',
      searchValueResidentialComplexes: '',
      typesDoorphone: [
        { name: 'Домофон', value: 'M' },
        { name: 'Доп.вход', value: 'A' },
        { name: 'Виртуальная калитка', value: 'virtualGate' },
      ],
      headersResidentialComplexes: [
        { text: 'id', value: 'id' },
        { text: 'Название', value: 'name', sortable: false },
        { text: '', value: 'actions', width: '15%', sortable: false },
      ],
      visibleColumns: [],
      allColumns: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', width: '20%' },
        { text: 'Регион', value: 'region_name', width: '20%' },
        { text: 'Диспетчерская', value: 'concierge_number', sortable: false },
        { text: 'Агент', value: 'agent', width: '10%', sortable: false },
        { text: 'Диапазон квартир', value: 'diapason', sortable: false, width: '5%' },
        { text: 'Управляющая компания', value: 'management_company', sortable: false },
        { text: 'Компания-собственник', value: 'management_group', sortable: false },
        { text: 'Участок МТО', value: 'mto_sector', sortable: false, width: '12%' },
        { text: 'Статус', value: 'sip_status', width: '13%', sortable: false },
        { text: 'Изображение с домофона', value: 'snapshotImage', sortable: false },
        { text: 'Модель домофона', value: 'model', sortable: false },
        { text: 'АП ЭВО Лайф', value: 'payment_type', sortable: false },
        { text: 'АП "Домофон"', value: 'tariff', sortable: false },
        { text: 'Комментарий', value: 'comment', sortable: false },
      ],
      showColumnSelector: false,
      sipSelectList: [
        { text: 'Отключен', value: '0' },
        { text: 'Регистрация', value: '1' },
        { text: 'Зарегистрирован', value: '2' },
        { text: 'Не удалось зарегистрироваться', value: '3' },
        { text: 'Не установлен', value: '4' },
        { text: 'Без интернет соединения', value: '5' },
        { text: 'Пусконаладка', value: '6' },
        { text: 'Старый домофон', value: '7' },
        { text: 'Ожидает монтажа', value: '8' },
        { text: 'Не в сети', value: 'null' },
        { text: 'Не зарегистрирован', value: '-1' },
      ],
      resultDialog: false,
      massResult: {
        summary: null,
        results: [],
      },
      resultHeaders: [
        { text: 'ID', value: 'id', align: 'center', sortable: false },
        { text: 'Статус', value: 'status', align: 'center', sortable: false },
        { text: 'Новый SIP статус', value: 'sip_status', align: 'center', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
    settingsTables: {
      immediate: true,
      async handler (val) {
        if (!val || !val.length || this.visibleColumns.length) return;
        const tableSettings = val.find(item => item.table_key === 'doorphones');
        this.visibleColumns = Array.isArray(tableSettings?.visible_columns) && tableSettings.visible_columns.length
          ? [...tableSettings.visible_columns]
          : this.allColumns.map(col => col.value);

        this.loadingSettings = true;
        await new Promise(resolve => setTimeout(resolve, 300));
        this.loadingSettings = false;
      },
    },
  },
  created () {
    this.isCreated = true;
    this.sort = ['-id'];
    if (Object.keys(this.$route.query).length) {
      const routeQuery = this.$route.query;

      if (routeQuery.address) {
        this.filterAddress = routeQuery.address;
        this.filters.address = routeQuery.address;
      }
      if (routeQuery.type) {
        this.filterType = routeQuery.type;
        this.filters.type = routeQuery.type;
      }
      if (routeQuery.management_company_id) {
        this.filterManagementCompany = routeQuery.management_company_id;
        this.filters.management_company_id = routeQuery.management_company_id;
      }
      if (routeQuery.is_safe_city) {
        this.isSafeCityDoorphone = routeQuery.is_safe_city;
        this.filters.is_safe_city = routeQuery.is_safe_city;
      }
      if (routeQuery.agent_id) {
        this.filterAgent = routeQuery.agent_id;
        this.filters.agent_id = routeQuery.agent_id;
      }
      if (routeQuery.mto_sector_id) {
        this.filterMtoSector = Number(routeQuery.mto_sector_id);
        this.filters.mto_sector_id = routeQuery.mto_sector_id;
      }
      if (routeQuery.status) {
        this.sipStatusSearched = routeQuery.status;
        this.filters.status = routeQuery.status;
      }
    }
    switch (this.roleName) {
      case 'call-center' : case 'manager' : this.disableFilterName = false;
        break;
    }
    if (this.disableFilterName && !this.agents?.length) {
      this.loadAllAgents();
    }
    this.loadMtoSectorOptions();
    this.loadDoorphones();
    if (this.disableFilterName) {
      this.loadManagementCompanies({
        filters: { with_doorphones: 1 },
      });
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      agents: 'Agents/agents',
      doorphones: 'Doorphone/doorphones',
      settingsTables: 'User/settingsTables',
      managementCompanies: 'ManagementCompany/managementCompanies',
      mtoSectors: 'MtoSector/mtoSectors',
    }),
    doorphoneSettings () {
      return this.settingsTables.find(item => item.table_key === 'doorphones') || {};
    },
    headersDoorphone () {
      return this.allColumns
        .filter(col => this.visibleColumns.includes(col.value))
        .filter(col => col.value !== 'snapshotImage' || this.isDisplaySmall);
    },
    mtoSectorOptions () {
      return this.mtoSectors || [];
    },
    isMtoSectorFilterDisabled () {
      return this.disableFilterName && !this.filterAgent;
    },
    mtoSectorFilterHint () {
      if (this.disableFilterName && !this.filterAgent) {
        return 'Сначала выберите агента';
      }
      return '';
    },
  },
  methods: {
    ...mapActions({
      loadAllAgents: 'Agents/loadAllAgents',
      getDoorphones: 'Doorphone/getDoorphones',
      deleteDoorphone: 'Doorphone/deleteDoorphone',
      exportCsv: 'Doorphone/exportCsv',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
      massSipStatus: 'Doorphone/massSipStatus',
      deleteComplex: 'ResidentComplex/deleteComplex',
      getMtoSectors: 'MtoSector/getMtoSectors',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth >= 600;
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    getPaymentType (item) {
      if (item === 'A') {
        return '50 руб. в месяц';
      }
      if (item === 'M') {
        return '0 рублей.';
      }
      if (item === 'G') {
        return '0 рублей.';
      }
      return '';
    },
    getSipStatusText (code) {
      if (code === null || code === undefined) return 'Не в сети';
      const map = {
        '-1': 'Не зарегистрировано',
        0: 'Отключено',
        1: 'Регистрация',
        2: 'Зарегистрировано',
        3: 'Не удалось зарегистрироваться',
      };
      const key = typeof code === 'number' ? code : String(code);
      return map[key] || '—';
    },
    clickDoorphone (event, value) {
      if (this.$canRoute('DetailDoorphone')) {
        if (event.ctrlKey) {
          this.clickDoorphoneWhell(value);
        } else {
          this.detailDoorphone(value);
        }
      }
    },
    clickDoorphoneWhell (id) {
      const routeData = this.$router.resolve({ name: 'DetailDoorphone', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    detailDoorphone (value) {
      let { id } = value;
      if (!id) {
        id = value;
      }
      this.$router.push({ name: 'DetailDoorphone', params: { id: id } });
    },
    rowDetailDoorphone (value) {
      if (!this.isDisplaySmall) {
        this.detailDoorphone(value);
      }
    },
    openEditEnter (item) {
      let tabId = 0;
      switch (item.model) {
        case 'RV-3434': tabId = 3;
          break;
        case 'RV-3438': tabId = 6;
          break;
        case 'E12': tabId = 1;
          break;
        case 'DKS15134': tabId = 4;
          break;
        case 'DKS20211': tabId = 4;
          break;
        case 'DKS1512': tabId = 4;
          break;
        default:
          break;
      }
      this.$router.push({ name: 'EditDoorphone', params: { id: item.id, tabId: tabId } });
    },
    openingAdditionalLine (index) {
      if (this.visibleIndex === index) {
        this.isLinksVisible = false;
        this.visibleIndex = null;
      } else {
        this.isLinksVisible = true;
        this.visibleIndex = index;
      }
    },
    downloadReportPage () {
      const lines = [];
      this.doorphones.forEach((item) => {
        let managementCompany = '';
        let managementCompanyGroup = '';
        let sipStatusChangeTime = '';
        if (item.management_group) {
          managementCompanyGroup = item.management_group;
        } else {
          managementCompanyGroup = '';
        }
        if (item.management_company) {
          managementCompany = item.management_company;
        } else {
          managementCompany = '';
        }
        if (item.sip_status_change_time) {
          sipStatusChangeTime = this.ruDateFormat(item.sip_status_change_time);
        } else {
          sipStatusChangeTime = '';
        }
        const line = [
          item.id, item.address, item.dispatcher_phone || item.concierge_number, item.agent,
          item.diapason, managementCompany, managementCompanyGroup, item.sip_status_text, sipStatusChangeTime,
        ].join(';');
        lines.push(line);
      });
      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'doorphones-page.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadReport () {
      this.exportCsv()
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response], {
            type: 'application/csv',
          }));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'doorphones.csv';
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании полного отчёта');
        });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'A,M' };

      if (this.filterAddress) {
        this.filters.address = this.filterAddress;
      }
      if (this.sipStatusSearched) {
        this.filters.status = this.sipStatusSearched;
      }
      if (this.filterManagementCompany) {
        this.filters.management_company_id = this.filterManagementCompany;
      }
      if (this.filterAgent) {
        this.filters.agent_id = this.filterAgent;
      }
      if (this.filterMtoSector) {
        this.filters.mto_sector_id = this.filterMtoSector;
      }
      if (this.filterType) {
        if (this.filterType === 'virtualGate') {
          this.filters.virtual_gate = 1;
        } else {
          this.filters.type = this.filterType;
        }
      }
      if (this.isSafeCityDoorphone) {
        this.filters.is_safe_city = 1;
      } else {
        delete this.filters.is_safe_city;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
          type: this.filters.type,
          safeCity: this.filters.is_safe_city,
          agent: this.filters.agent_id,
          mto_sector_id: this.filters.mto_sector_id,
          status: this.filters.status,
          managementCompany: this.filters.management_company_id,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    showSafeCity () {
      this.options.page = 1;
      this.filterDoorphones();
    },
    onAgentFilterChange () {
      this.filterMtoSector = '';
      delete this.filters.mto_sector_id;
      this.loadMtoSectorOptions();
    },
    async loadMtoSectorOptions () {
      if (this.disableFilterName && !this.filterAgent) {
        return;
      }

      this.mtoSectorsLoading = true;
      const options = {};
      if (this.filterAgent) {
        options.agent_id = this.filterAgent;
      }

      try {
        await this.getMtoSectors(options);
      } catch (e) {
        this.$flash_warning('Не удалось загрузить участки МТО');
      } finally {
        this.mtoSectorsLoading = false;
      }
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadDoorphones () {
      this.isLinksVisible = false;
      this.$router.push({
        query: {
          address: this.filters.address,
          type: this.filters.type,
          safeCity: this.filters.is_safe_city,
          agent: this.filters.agent_id,
          mto_sector_id: this.filters.mto_sector_id,
          status: this.filters.status,
          managementCompany: this.filters.management_company_id,
          // page: this.options.page,
        },
      }).catch(() => {});
      this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((response) => {
          this.totalDoorphones = response.meta.total;
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке домофонов');
        });
    },
    async onMassSipStatus () {
      try {
        this.isMassSipLoading = true;
        const ids = this.doorphones.map(d => d.id);
        const response = await this.massSipStatus({ ids });
        await this.loadDoorphones();
        const data = response && response.data ? response.data : {};
        this.massResult.summary = data.summary || null;
        this.massResult.results = Array.isArray(data.results) ? data.results : [];
        this.resultDialog = true;
      } catch (error) {
        console.error(error);
        this.$flash_warning && this.$flash_warning('Ошибка при массовом обновлении SIP-статусов');
      } finally {
        this.isMassSipLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Шапка страницы
.doorphones-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
}

.doorphones-header__title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.doorphones-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.doorphones-header__btn {
  text-transform: none;
  font-weight: 500;
}

.doorphones-report-menu .v-list-item {
  min-height: auto;
}

.doorphones-block {
  border-radius: 12px;
  overflow: hidden;
}

.doorphones-filters {
  padding: 10px 16px 8px;
}

.doorphones-filters__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.doorphones-filters__main {
  flex: 1;
  min-width: 0;
}

.doorphones-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.doorphones-filters__field {
  max-width: 320px;
  width: 100%;
}

.doorphones-filters__search-wrap {
  display: flex;
  align-items: center;
}

.doorphones-filters__switch-wrap {
  display: flex;
  align-items: center;
}

.doorphones-filters__columns {
  flex-shrink: 0;
  align-self: center;
}

.doorphones-filters__columns ::v-deep .v-btn {
  margin-right: 0;
}

.doorphones-safe-city {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 2px 10px 2px 4px;
  transition: border-color 0.2s, background-color 0.2s;

  &--active {
    border-color: rgba(90, 138, 93, 0.5);
    background: rgba(90, 138, 93, 0.08);
  }
}

.doorphones-table {
  margin: 0;
}

.doorphones-result-dialog__title {
  background: linear-gradient(135deg, #5a8a5d 0%, #4d7a50 100%);
  color: #fff;
  font-weight: 600;
}

.filters-doorphones {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
  gap: 6px 8px;
  grid-auto-rows: auto;
  align-items: start;
}

.filters-doorphones-selectively-role-name {
  grid-template-columns: repeat(5, 1fr);
}

.row-click {
  cursor: pointer;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

.row {
  margin-bottom: 0;
  margin-top: 0;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.4s ease;
}

.door-item {
  display: flex;
  flex-direction: column;
}

.nested-container {
  display: inline-flex;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.door-info {
  display: inline-block;
  padding-right: 10px;
  margin-right: 10px;
}

@media screen and (max-width: 900px) {
  .display-row-mobile {
    display: contents;
  }
}

@media screen and (max-width: 600px) {
  .doorphones-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .doorphones-header__title {
    font-size: 1.4rem;
  }

  .filters-doorphones {
    display: block;
  }

  .doorphones-filters__field {
    max-width: none;
  }

  .doorphones-filters__search-wrap {
    margin-bottom: 8px;
  }

  .doorphones-filters__switch-wrap {
    margin-top: 4px;
  }

  .doorphones-filters__row {
    flex-direction: column;
    align-items: stretch;
  }

  .doorphones-filters__columns {
    align-self: flex-end;
  }
}
</style>
